"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonBack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const router_1 = require("next/router");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../../styles");
const hooks_1 = require("../../hooks");
exports.ButtonBack = (0, react_1.memo)(({ sticky = false }) => {
    const scrollState = (0, hooks_1.useScrollTracker)(80);
    const scrollTop = (0, react_1.useMemo)(() => scrollState === 'TOP', [scrollState]);
    const router = (0, router_1.useRouter)() || { back: () => { } };
    const onClick = () => {
        router.back();
    };
    return ((0, jsx_runtime_1.jsx)(Button, Object.assign({ sticky: sticky, scrollTop: scrollTop, onClick: onClick, title: 'Ir atr\u00E1s' }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--chevron--white.svg', alt: 'Icon arrow back', width: '16', height: '16' }) })));
});
const Button = styled_components_1.default.button `
  align-items: center;
  background-color: #262626;
  border-radius: ${({ sticky }) => sticky ? 0 : '50%'};
  display: flex;
  height: ${(0, styles_1.vw)(50, 'mobile')};
  justify-content: center;
  left: ${(0, styles_1.vw)(20, 'mobile')};
  position: fixed;
  top: 82px;
  transition: 200ms all ${({ theme }) => theme.ease};
  width: ${(0, styles_1.vw)(50, 'mobile')};
  z-index: 20;

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(50, 'nexus7')};
    left: ${(0, styles_1.vw)(20, 'nexus7')};
    width: ${(0, styles_1.vw)(50, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${(0, styles_1.vw)(80, 'desktop')};
    left: ${({ sticky }) => sticky ? 0 : `${(0, styles_1.vw)(20, 'desktop')}`};
    top: ${({ sticky, scrollTop }) => sticky ? '80px' : `${scrollTop ? '120px' : '92px'}`};
    width: ${({ sticky }) => (0, styles_1.vw)(sticky ? 120 : 80, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    height: 80px;
    left: ${({ sticky }) => sticky ? 0 : '20px'};
    top: ${({ sticky, scrollTop }) => sticky ? '80px' : `${scrollTop ? '120px' : '92px'}`};
    width: ${({ sticky }) => sticky ? '120px' : '80px'};
  }

  img {
    transform: rotate(90deg);
    width: ${(0, styles_1.vw)(8, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      width: ${(0, styles_1.vw)(8, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      width: ${(0, styles_1.vw)(18, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      width: 18px;
    }
  }
`;
